import { render } from "./BackCalc.vue?vue&type=template&id=9a628728&scoped=true"
import script from "./BackCalc.vue?vue&type=script&lang=js"
export * from "./BackCalc.vue?vue&type=script&lang=js"

import "./BackCalc.vue?vue&type=style&index=0&id=9a628728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a628728"]])

export default __exports__